export const WorkflowNewStep = {
  General: 0,
  Steps: 1,
  Participants: 2,
};
